export default __webpack_public_path__ + "static/media/health.3c104453.svg";